import api from './api';

const adminService = {
  getDashboardStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },

  getUsers: async (params = {}) => {
    const response = await api.get('/admin/users', { params });
    return response.data;
  },

  updateUser: async (id, data) => {
    const response = await api.put(`/admin/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  getOrders: async (params = {}) => {
    const response = await api.get('/admin/orders', { params });
    return response.data;
  },

  updateOrderStatus: async (id, status) => {
    const response = await api.put(`/admin/orders/${id}/status`, { order_status: status });
    return response.data;
  },

  getRestaurants: async (params = {}) => {
    const response = await api.get('/admin/restaurants', { params });
    return response.data;
  },

  updateRestaurant: async (id, data) => {
    const response = await api.put(`/admin/restaurants/${id}`, data);
    return response.data;
  },

  getPayments: async (params = {}) => {
    const response = await api.get('/admin/payments', { params });
    return response.data;
  },
};

export default adminService;
